/* global google */
import {Route, Routes} from "react-router";
import React from 'react';
import './App.css';
import {Header} from "./Header";
import {ProviderHome} from "./Home/ProviderHome";
import {RedeemBusinessInvite} from "./RedeemBusinessInvite/RedeemBusinessInvite";
import {RedeemTeamMemberInvite} from "./RedeemTeamMemberInvite/RedeemTeamMemberInvite";
import {AdminHeader} from "./AdminHeader/AdminHeader";
import {CheckBusinessInvite} from "./RedeemBusinessInvite/CheckBusinessInvite";
import {CheckTeamMemberInvite} from "./RedeemTeamMemberInvite/CheckTeamMemberInvite";
import {useKensuAuth} from "../util/authwrapper/AuthWrapper";
import {Root} from "./Root";
import {Discover} from "./Discover/Discover";

export const App = () => {

  return (
      <div className="App">
        <AdminHeaderAuthWrapper/>
        <Header/>
        <Body/>
      </div>
  );
}

/**
 * Ensures that there's a user before the admin header even tries to load stuff;
 * we don't want this to do the redirects.
 * @constructor
 */
const AdminHeaderAuthWrapper = () => {

  const {user} = useKensuAuth();
  if (user) {
    return <AdminHeader/>;
  }
}

/**
 * This is extracted from above so I can do if/else clauses for all the possible
 * options rather than {!profileError && !profileLoading && profile && ..} nonsense.
 */
const Body = () => {

  return <Routes>
    <Route path="/discover" element={<Discover/>}/>

    <Route path="/join" element={<CheckBusinessInvite/>}/>
    <Route path="/redeem" element={<RedeemBusinessInvite/>}/>

    <Route path="/joinTeam" element={<CheckTeamMemberInvite/>}/>
    <Route path="/redeemTeam" element={<RedeemTeamMemberInvite/>}/>

    <Route path="/home/*" element={<ProviderHome/>}/>
    <Route path="/" element={<Root/>}/>
  </Routes>
}

export default App;
